import { qs } from "../../lib/api/endpoints";

export const FINANCE_PATH = "/finance";
export const TRANSACTIONS_PATH = "/finance/transactions";
export const WITHDRAW_PATH = "/finance/withdraw";
export const WITHDRAWALS_PATH = "/finance/withdrawals";
export const TOP_UP_RETURN_PATH = "/finance/top-up/return";

export const financeReturnUrl = () => {
  try {
    return `${window.location.origin}${FINANCE_PATH}`;
  } catch {
    return null;
  }
};

export const withdrawPath = ({ amount, currency } = {}) =>
  `${WITHDRAW_PATH}${qs({ amount, currency })}`;

export const withdrawalDetailPath = (id) => `${WITHDRAWALS_PATH}/${id}`;

export const orderDetailPath = (orderId) => `/my-orders/detail?id=${orderId}`;
